module.exports = __webpack_public_path__ + "img/lock-august.020fb6a6.png";